import i18n from '@/assets/i18n/index';

type LocaleType = 'EN' | 'JP';
type DocLinks =
    | 'abtestUplift'
    | 'abtestProbability'
    | 'abtestMetrics'
    | 'abtestSetting'
    | 'integrationAppGA4';

const links: {
    [key in DocLinks]: string;
} = {
    abtestUplift: '/docs/ptx-report-abtest/#uplift',
    abtestProbability: '/docs/ptx-report-abtest/#probability to be best',
    abtestMetrics: '/docs/ptx-report-abtest/#the estimated key testing metrics',
    abtestSetting: '/docs/ptx-experience-abtest/#setting',
    integrationAppGA4: '/docs/integrating-ptengine-experience-with-google-analytics-4/'
};

export function getAreaForUrl() {
    const currentArea = /(ptmind|ptengine)\.com/.test(location.host) ? 'EN' : 'JP';
    return currentArea;
}

export function getWebsiteHost() {
    const currentArea = getAreaForUrl();
    const websiteHref =
        currentArea === 'EN'
            ? import.meta.env.VITE_PTENGINE_WEBSITE_EN_URL
            : import.meta.env.VITE_PTENGINE_WEBSITE_URL;
    return websiteHref;
}

export function getHelpCenterHost(locale?: LocaleType): string {
    const mapping = {
        JP: import.meta.env.VITE_HELP_LINK as string,
        EN: import.meta.env.VITE_HELP_LINK_EN as string
    };
    const host = mapping[locale || (i18n.global.locale as LocaleType)] || mapping.EN;
    return host || '';
}

/**
 * 获取帮助站链接地址
 */
export function useHelpLinks(key: DocLinks, locale?: LocaleType) {
    const host = getHelpCenterHost(locale);
    return host?.toString() + links[key];
}
